<template>
  <div>
    <video
      :id="playerId"
      :class="playerClass"
      :controls="controls"
      :loop="loop"
      :muted="muted"
      preload="auto"
      @click="click"
      @ended="ended"
      @playing="playing"
      @timeupdate="timeupdated"
      >
      <source :src="resolvedSrc" type="video/mp4" />
    </video>
  </div>
</template>

<script>
export default {
  computed: {
    resolvedSrc () {
      const currentLocale = this.$route.params.locale
      if (this.locale && currentLocale !== 'en') {
        return this.src + '_' + currentLocale + '.mp4'
      }
      return this.src + '.mp4'
    }
  },
  methods: {
    click () {
      console.log('click on ' + this.playerId)
      this.$emit('click')
    },
    ended () {
      console.log('VueVideo ' + this.playerId + ' @ended')
      this.$store.commit('zoomActuallyPlaying', false)
      this.$emit('ended')
    },
    playing () {
      this.$store.commit('zoomActuallyPlaying', true)
    },
    timeupdated () {
      this.$emit('updated', document.getElementById(this.playerId).currentTime)
    }
  },
  props: {
    autoplay: {
      type: Boolean,
      default: false
    },
    controls: {
      type: Boolean,
      default: false
    },
    locale: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      default: false
    },
    muted: {
      type: Boolean,
      default: true
    },
    playerId: {
      type: String,
      default: ''
    },
    playerClass: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      default: ''
    }
  }
}
</script>
